import { mergeClassNames } from "utils/common.js";

const PromotionsPaper = ({
	title,
	children,
}) => {

	return <div className={mergeClassNames('vs--promotions-paper')}>
		{title && <div className="vs--promotions-paper-title">{title}</div>}
		{children}
	</div>

}


export default PromotionsPaper